module.exports = __webpack_public_path__ + "img/ic_myjobs-enabled.0e96a47f.svg";